import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UiService } from './ui.service';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialogConfig } from '@angular/material/dialog/dialog-config';
import { MatDialogRef } from '@angular/material/dialog/dialog-ref';


@Injectable({providedIn: 'root'})
export class DialogService {
  constructor(
    private dialog: MatDialog,
    private uiService: UiService
  ) {
  }

  open<T, D = any, R = any>(template: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    const {direction} = this.uiService.directionObject();
    return this.dialog.open(template, Object.assign({}, config, {direction}));
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
